import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import TippspielWidget from '../TippspielWidget.js';

export default class LoginWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}
	
	onLoginReady() {
		Form.onSubmit(this.$widget, action => {
			Ajax.rpc('/login', {
				login: action.findField('login').val(),
				password: action.findField('password').val(),
				remember: action.findField('remember').is(':checked') ? true : false
			}, success => {
				if (success) {
					window.location.href = '/';
				} else {
					action.error('Unbekannter Name (bzw. Email) oder falsches Passwort.');
				}
			}, error => {
				action.error('Login fehlgeschlagen', error);
			});
		});
	}

}
